import { Button, Result, Skeleton } from 'antd'
import type { ReactNode } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useWorkspaceState } from './WorkspaceContext'

/**
 * VISTOERA_SAAS_TENANT_FEATURE_ENTITLEMENT_MATRIX_V1 §24 — real route
 * gating, not just a hidden nav item. A Workspace without `featureKey`
 * entitled gets a clear "功能未开通" screen for direct/typed-in URL
 * access — never a blank page, a fake 404, or a JS error. The backend
 * API for the same feature independently enforces the same gate via
 * `require_workspace_feature` (see `app.saas.auth_deps`), so this is a
 * UX nicety on top of a real 403, never the only line of defense.
 */
export default function RequireFeature({ featureKey, children }: { featureKey: string; children: ReactNode }) {
  const { workspaceId = '' } = useParams()
  const navigate = useNavigate()
  const { entitlements, loading } = useWorkspaceState()

  if (loading) return <Skeleton active style={{ padding: 24 }} />

  if (!entitlements[featureKey]) {
    return (
      <Result
        status="403"
        title="功能未开通"
        subTitle="该功能当前未对本工作区开放，如需使用请联系平台管理员。"
        extra={
          <Button type="primary" onClick={() => navigate(`/workspace/${workspaceId}/overview`)}>
            返回概览
          </Button>
        }
      />
    )
  }

  return <>{children}</>
}
